<template>
  <section id="section-3" class="content-current">
    <div class="row">
      <div class="col-md-11"></div>
      <div class="col-md-1">
        <router-link to="/profile/dashboard">
          <div title="بازگشت به داشبورد" class="close"></div>
        </router-link>
      </div>
    </div>
    <div class="content-current">
      <div class="row">
        <div class="col-md-6">
          <!-- <div class="group_mdi inputContainer">
            <div class="icon-position">
              <i class="icon_calendar icon"></i>
            </div>
            <input
              type="text"              
              v-datepicker="{ maxDate: now }"
              :value="convertDate(fromDate)"
              @change="fromDate = $event.detail.GregorianDate"
            />
               <span class="highlight"></span><span class="bar"></span>
            <label>از تاریخ </label>
          </div> -->
          <label class="">از تاریخ:</label>
          <date-picker display-format="jYYYY/jMM/jDD" color="#00C3E1" popover="bottom-right" auto-submit locale="fa"
            v-model="fromDate" />
          <span class="highlight"></span><span class="bar"></span>
        </div>
        <div class="col-md-6">
          <!-- <div class="group_mdi inputContainer">
            <div class="icon-position">
              <i class="icon_calendar icon"></i>
            </div>
            <input type="text" v-datepicker :value="convertDate(toDate)"
              @change="toDate = $event.detail.GregorianDate" />
            <span class="highlight"></span><span class="bar"></span>
            <label>تا تاریخ</label>
          </div> -->
          <label class="">تا تاریخ:</label>
          <date-picker display-format="jYYYY/jMM/jDD" color="#00C3E1" popover="bottom-right" auto-submit locale="fa"
            v-model="toDate" />
          <span class="highlight"></span><span class="bar"></span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="group_mdi">

            <input type="text" v-model="referenceCode" />
            <span class="highlight"></span><span class="bar"></span>
            <label> شماره خرید</label>
          </div>
        </div>
        <div class="col-md-6">
          <div class="group_mdi">
            <input type="text" v-model="requestCode" />
            <span class="highlight"></span><span class="bar"></span>
            <label> شماره درخواست</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 btn-align">
          <button type="submit" class="btn btn-primary" @click="search">
            جستجو
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div class="col-md-12 loading" v-if="isLoading">
      <loadingBar type="ripple" />
    </div>
    <table class="table tablesorter add_bottom_30" v-if="!isLoading">
      <thead class="thead-light">
        <tr>
          <th>نام آژانس</th>
          <th>تاریخ ثبت</th>
          <th>وضعیت</th>
          <th>شماره درخواست</th>
          <th>شماره خرید</th>
          <th>افزایش</th>
          <th>کاهش</th>
          <th>باقی مانده</th>
          <th>جزئیات</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, index) in creditList">
          <tr>
            <td>{{ item.sourceName }}</td>
            <td>{{ item.date | persianDate("jYYYY/jMM/jDD") }}</td>
            <td v-if="item.status == 'Success'">موفق</td>
            <td v-if="item.status != 'Success'">ناموفق</td>
            <td>{{ item.requestCode }}</td>
            <td>{{ item.referenceCode }}</td>
            <td>{{ item.credit | numFormat }}</td>
            <td>{{ item.debt | numFormat }}</td>
            <td>{{ parseInt(item.balance) | numFormat }}</td>
            <td @click="toggle(index + 1)" :class="{ opened: opened.includes(index + 1) }">
              <i class="icon-th" style="color: #008489; font-size: 20px"></i>
            </td>
          </tr>

          <tr v-if="opened.includes(index + 1)">
            <td class="td-opened" colspan="6">
              توضیحات : {{ item.description }}
            </td>
            <td class="td-opened" colspan="6">
              نوع سرویس : {{ item.serviceType }}
            </td>
          </tr>

          <tr v-if="opened.includes(index + 1)">
            <td class="td-opened" colspan="6">کاربر : {{ item.userName }}</td>
            <td class="td-opened" colspan="6">کدآژانس : {{ item.sourceId }}</td>
          </tr>
        </template>
      </tbody>
    </table>

    <div class="btn-align">
      <h3 v-if="hasShowResult">نتیجه ای یافت نشد !!!!</h3>
    </div>
  </section>
</template>

<script>
import Store from "../../../views/profile/store/index";
import moment from "moment-jalaali";
import loadingBar from "../../../components/loading/pdkLoadingBar";
import date from "../../../utils/date";

export default {
  name: "creditReport",
  store: Store,
  components: { loadingBar },
  data() {
    return {
      now: moment(),
      isLoading: false,
      opened: [],
      sourceList: [],
      creditList: [],
      sourceProfileId: "",
      fromDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      toDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      isAdmin: false,
      referenceCode: "",
      requestCode: "",
      contentVisible: false,
      hasShowResult: false,
      tourismType: "P",
    };
  },
  created() {
    // this.getSourceList();

    this.getTourismType()
  },

  methods: {
    getTourismType() {
      const tourismType = this.$route.params.tourismType;
      if (tourismType === "fastTrack") this.tourismType = "FT";
      else this.tourismType = "P";
    },
    // convertDate(date) {
    //   if (date === "0001-01-01T00:00:00") return "";
    //   if (!moment(date).isValid()) return "";
    //   const pdate = moment(date).format("jYYYY/jMM/jDD");
    //   return pdate;
    // },
    getSourceList() {
      this.sourceList = this.$store.getters.GetAllSourceConfirmed;
    },
    search() {

      const data = {
        fromDate: date.ConvertToGregorianDashFormat(this.fromDate),
        toDate: date.ConvertToGregorianDashFormat(this.toDate),
        isAdmin: this.isAdmin,
        serviceType: this.tourismType,
        sourceProfileId: localStorage.getItem("SourceProfileId"),
        referenceCode: this.referenceCode,
        requestCode: this.requestCode,
      }

      this.$store.dispatch("getDepositReport", data)
        .then((res) => {
          this.isLoading = true;
          console.log(res, "resresresresres")
          this.creditList = res;

          if (res != 0) {
            this.creditList = res;
            this.hasShowResult = false;
          } else {
            this.creditList = [];
            this.hasShowResult = true;
          }
          this.isLoading = false;
        }).catch((error) => {
          return console.log(error)
        });




      // this.$store.dispatch("getDepositReport", data)
      //   .then((res) => {
      //     debugger
      //     console.log(res,"resresresresres")
      //     this.creditList = res;

      //     if (res.length != 0) {
      //       this.creditList = res;
      //       this.hasShowResult = false;
      //     } else {
      //       this.creditList = [];
      //       this.hasShowResult = true;
      //     }
      //     this.isLoading = false;
      //   });

    },
    toggle(id) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened.push(id);
      }
    },
  },
};
</script>

<style scoped>
.btn-profile {
  width: 180px !important;
}

.btn-align {
  /* text-align: center; */
  margin-top: 20px !important;

  /* padding-right: 70px !important;
  padding-left: 70px !important; */
}

.icon-top {
  margin-top: 38px;
  font-size: 40px;
}

.icon-bottom {
  margin-top: 38px;
  font-size: 22px;
}

.icon-position {
  float: left;
  margin-left: 26px;
}

/* .opened {
  background-color: yellow;
} */
.td-opened {
  background-color: rgb(4 112 167) !important;
  color: white;
}

.loading {
  height: 1000px !important;
  text-align: center !important;
  margin-top: 200px !important;
}

h3 {
  color: #777 !important;
}
</style>